import React from 'react';
import { Link } from 'react-router-dom';
import { blogArticles } from '../data/mockData';
import { ArrowRight, Clock } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import MobileSlider from './MobileSlider';

const BlogCard = ({ article, index }) => {
  const card = useScrollAnimation({ threshold: 0.1 });
  return (
    <Link to={`/blog/${article.slug}`} ref={card.ref} data-testid={`blog-card-${article.id}`}
      className={`group block rounded-2xl border border-[#E2E2F0] bg-white overflow-hidden h-full
        transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_50px_-12px_rgba(99,102,241,0.15)] hover:border-[#C7D2FE]
        scroll-fade-up scroll-delay-${index+1} ${card.isVisible?'scroll-visible':''}`}>
      <div className="h-44 overflow-hidden bg-[#F5F3FF]">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-2">
          <span className="text-[10px] font-semibold uppercase tracking-[0.15em] text-[#6366F1]">{article.category}</span>
          <span className="text-[10px] text-[#4B5563]">&middot; {article.date}</span>
        </div>
        <h3 className="text-lg font-semibold text-[#1E1B4B] mb-2 tracking-tight group-hover:text-[#6366F1] transition-colors" style={{fontFamily:"'Playfair Display',serif"}}>{article.title}</h3>
        <p className="text-sm font-normal text-[#4B5563] leading-relaxed mb-3 line-clamp-2">{article.excerpt}</p>
        <div className="flex items-center justify-between pt-3 border-t border-[#E2E2F0]">
          <div className="flex items-center gap-1.5 text-[11px] text-[#4B5563]"><Clock className="w-3.5 h-3.5" strokeWidth={1.5} />{article.readTime}</div>
          <span className="text-sm font-medium text-[#6366F1] flex items-center gap-1 group-hover:gap-2 transition-all">Read More <ArrowRight className="w-3.5 h-3.5" /></span>
        </div>
      </div>
    </Link>
  );
};

const BlogSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });
  return (
    <section id="blog" data-testid="blog-section" className="py-16 md:py-32 bg-[#F5F3FF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={header.ref} className={`mb-10 md:mb-16 scroll-fade-up ${header.isVisible?'scroll-visible':''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-3 block font-semibold">Insights & Guidance</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] mb-4" style={{fontFamily:"'Playfair Display',serif"}}>From Our Knowledge Base.</h2>
          <p className="text-base font-normal text-[#4B5563] leading-relaxed max-w-lg">Expert perspectives on trademark strategy, intellectual property law, and practical steps.</p>
        </div>
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {blogArticles.map((a,i)=><BlogCard key={a.id} article={a} index={i} />)}
        </div>
        <div className="md:hidden">
          <MobileSlider>{blogArticles.map((a,i)=><BlogCard key={a.id} article={a} index={i} />)}</MobileSlider>
        </div>
      </div>
    </section>
  );
};
export default BlogSection;
